import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {
    Button, List, Divider, Typography,
} from "@material-ui/core";
import {Droppable} from 'react-beautiful-dnd'
import Card from "@material-ui/core/Card";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Legend from "./Legend";
import RenderColumns from "./RenderColumns";
import '../columns.css'

const useStyles = makeStyles(() => ({
    cardContentWrapper: {
        height: 485,
        width: 200,
        overflowX: "hidden",
    },
    list: {
        paddingTop: 0,
    },
    fieldset: {
        padding: 2,
        border: `1px solid #e5e5e5`,
        boxShadow: 'none',
        height: '100%',
        marginRight: 5
    },
}));

const SourceColumns = (props) => {
    const {
        columns, sourceColumns, data,
        onSelectAll, checkBoxChange, getColumns,
    } = props;
    const classes = useStyles();
    const [expanded, setExpanded] = useState({});

    function expandColumn(name) {
        setExpanded(prevState => {
            return {
                ...prevState,
                [name]: !Boolean(prevState[name])
            }
        })
    }

    return (
        <Card className={classes.fieldset}>
            <Legend
                sourceColumns={sourceColumns}
                columns={columns}
                data={data}
                getColumns={getColumns}
                onSelectAll={onSelectAll}
            />
            <Divider/>
            <Droppable
                droppableId={'sourceItems'}>
                {(provided) => (
                    <div className={classes.cardContentWrapper}
                         {...provided.droppableProps}
                         ref={provided.innerRef}>
                        <Droppable
                            droppableId={'source'}
                            isDropDisabled={true}
                        >
                            {(provided) => (
                                sourceColumns.length > 0 ? (
                                    <>
                                        <List
                                            dense={true}
                                            className={classes.list}
                                            {...provided.droppableProps}
                                            innerRef={provided.innerRef}>
                                            <RenderColumns
                                                sourceColumns={sourceColumns}
                                                checkBoxChange={checkBoxChange}
                                                expanded={expanded}
                                                expandColumn={expandColumn}
                                            />
                                        </List>
                                        <div style={{display: 'none'}}>
                                            {provided.placeholder}
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <div style={{textAlign: 'center'}}
                                             {...provided.droppableProps}
                                             ref={provided.innerRef}
                                        >
                                            <Typography>
                                                No Columns
                                            </Typography>
                                            <Button
                                                size={"small"}
                                                color={"primary"}
                                                variant={"contained"}
                                                onClick={() => getColumns(data.source)}
                                            >
                                                Get Columns
                                            </Button>
                                        </div>
                                        <div style={{display: 'none'}}>
                                            {provided.placeholder}
                                        </div>
                                    </>
                                )
                            )}
                        </Droppable>
                    </div>
                )}
            </Droppable>
        </Card>
    )
};

export default SourceColumns

SourceColumns.propTypes = {
    columns: PropTypes.array,
    sourceColumns: PropTypes.array,
    onSelectAll: PropTypes.func,
    checkBoxChange: PropTypes.func,
    getColumns: PropTypes.func,
    data: PropTypes.object
};

SourceColumns.defaultProps = {
    data: {}
};